import { render, staticRenderFns } from "./AdminProductDiscover.vue?vue&type=template&id=de2d8154"
import script from "./AdminProductDiscover.vue?vue&type=script&lang=js"
export * from "./AdminProductDiscover.vue?vue&type=script&lang=js"
import style0 from "./AdminProductDiscover.vue?vue&type=style&index=0&id=de2d8154&prod&lang=scss"
import style1 from "./AdminProductDiscover.vue?vue&type=style&index=1&id=de2d8154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports